import { INovaEntity } from './base';

export interface ICompany extends INovaEntity {
  name: string;
  scac: string;
  mc: string;
  usdot: string;
  type?: CompanyType;
}

export enum CompanyType {
  BROKER = 'type_broker',
  CARRIER = 'type_carrier',
  CARRIER_BROKER = 'type_carrier_broker',
  FORWARDER = 'type_forwarder'
}

/** Tag applied to carrier companies created via ShipperGuide `POST /company/resolve`. */
export const SHIPPERGUIDE_CREATED_COMPANY_TAG = '__shipperguide_created';

/**
 * Public / consumer email domains excluded from ShipperGuide company resolve matching.
 * Corporate domains (e.g. superapi.net) remain eligible.
 */
export const GENERIC_EMAIL_DOMAINS = new Set([
  'aol.com',
  'gmail.com',
  'googlemail.com',
  'gmx.com',
  'gmx.net',
  'hotmail.com',
  'icloud.com',
  'live.com',
  'mac.com',
  'mail.com',
  'me.com',
  'msn.com',
  'outlook.com',
  'proton.me',
  'protonmail.com',
  'yahoo.com',
  'ymail.com'
]);

export function isGenericEmailDomain(domain: string): boolean {
  return GENERIC_EMAIL_DOMAINS.has(domain.trim().toLowerCase());
}
